import { render, staticRenderFns } from "./recomProducts.vue?vue&type=template&id=b60a1c78&scoped=true&"
import script from "./recomProducts.vue?vue&type=script&lang=js&"
export * from "./recomProducts.vue?vue&type=script&lang=js&"
import style0 from "./recomProducts.vue?vue&type=style&index=0&id=b60a1c78&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60a1c78",
  null
  
)

export default component.exports